import "./SearchUserProfile.css";
import xyzprofile from "../../../assets/images/profile/userProfile.png";
import api from "../../../api/axios";
import { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";

export default function SearchUserProfile({
  SearchData,
  onClose,
  activeIndex,
  setActiveIndex,
  onSelectUser,
}) {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  // ===== HARD GUARD =====
  const trimmedSearch = SearchData?.trim();

  const isActive =
    typeof trimmedSearch === "string" && trimmedSearch.length > 0;

  // ===== FETCH USERS =====
  useEffect(() => {
    if (!trimmedSearch) {
      setUsers([]);
      setLoading(false);
      return;
    }

    const controller = new AbortController();

    const fetchUsers = async () => {
      try {
        setLoading(true);

        const res = await api.get(
          `/search/?query=${encodeURIComponent(trimmedSearch)}`,
          {
            signal: controller.signal,
          }
        );

        if (!controller.signal.aborted) {
          setUsers(res.data?.users || []);
        }
      } catch (err) {
        // Ignore cancelled requests
        if (
          err.name !== "CanceledError" &&
          err.name !== "AbortError"
        ) {
          setUsers([]);
        }
      } finally {
        if (!controller.signal.aborted) {
          setLoading(false);
        }
      }
    };

    fetchUsers();

    return () => {
      controller.abort();
    };
  }, [trimmedSearch]);

  // ===== ENTER KEY HANDLER =====
  useEffect(() => {
    if (!isActive || users.length === 0) return;

    const handleKey = (e) => {
      if (e.key !== "Enter") return;

      const selectedUser = users[activeIndex];

      if (!selectedUser) return;

      // ===== CLEAR SEARCH FIRST =====
      onSelectUser(selectedUser);

      navigate(`/user/${selectedUser._id}/profile`);

      onClose();
    };

    window.addEventListener("keydown", handleKey);

    return () => {
      window.removeEventListener("keydown", handleKey);
    };
  }, [
    users,
    activeIndex,
    isActive,
    navigate,
    onClose,
    onSelectUser,
  ]);

  // ===== DON'T RENDER =====
  if (!isActive) return null;

  return (
    <section>
      <div className="Search-Container">
        {loading ? (
          <div className="no-results">Searching...</div>
        ) : users.length > 0 ? (
          users.map((user, index) => (
            <Link
              key={user._id}
              to={`/user/${user._id}/profile`}
              onClick={() => {
                onSelectUser(user);
                onClose();
              }}
              style={{
                textDecoration: "none",
                color: "inherit",
              }}
            >
              <div
                className={`user-profile-img ${
                  index === activeIndex ? "active" : ""
                }`}
                onMouseEnter={() => setActiveIndex(index)}
              >
                <img
                  src={user.profilePic || xyzprofile}
                  alt="user"
                />

                <div className="user-info">
                  <h4>{user.fullName}</h4>
                  {(user?.statePublic || user?.districtPublic) && (
                    <h5>
                      {[user?.statePublic, user?.districtPublic].filter(Boolean).join(", ")}
                    </h5>
                  )}
                </div>
              </div>
            </Link>
          ))
        ) : (
          <div className="no-results">No users found</div>
        )}
      </div>
    </section>
  );
}


// import "./SearchUserProfile.css";
// import xyzprofile from "../../../assets/images/profile/userProfile.png";
// import api from "../../../api/axios";
// import { useEffect, useState } from "react";
// import { useNavigate, Link } from "react-router-dom";

// export default function SearchUserProfile({
//   SearchData,
//   onClose,
//   activeIndex,
//   setActiveIndex,
//   onSelectUser,
// }) {
//   const [users, setUsers] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const navigate = useNavigate();

//   // ✅ HARD GUARD (MOST IMPORTANT)
// const isActive = typeof SearchData === "string" && SearchData.trim().length > 0;

//   // useEffect(() => {
//   //   if (!isActive) {
//   //     setUsers([]);
//   //     return;
//   //   }

//   //   let isCancelled = false; // ✅ prevent async update

//   //   const fetchUsers = async () => {
//   //     try {
//   //       setLoading(true);
//   //       const res = await api.get(`/search/?query=${SearchData}`);

//   //       if (!isCancelled) {
//   //         setUsers(res.data?.users || []);
//   //       }
//   //     } catch (err) {
//   //       if (!isCancelled) {
//   //         setUsers([]);
//   //       }
//   //     } finally {
//   //       if (!isCancelled) {
//   //         setLoading(false);
//   //       }
//   //     }
//   //   };

//   //   fetchUsers();

//   //   return () => {
//   //     isCancelled = true; // ✅ cancel outdated calls
//   //   };
//   // }, [SearchData, isActive]);

//   useEffect(() => {
//   if (!SearchData || SearchData.trim().length === 0) {
//     setUsers([]);
//     return;
//   }

//   const controller = new AbortController(); // ✅ REAL cancellation

//   const fetchUsers = async () => {
//     try {
//       setLoading(true);

//       const res = await api.get(`/search/?query=${SearchData}`, {
//         signal: controller.signal, // ✅ attach signal
//       });

//       setUsers(res.data?.users || []);
//     } catch (err) {
//       if (err.name !== "CanceledError") {
//         setUsers([]);
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   fetchUsers();

//   return () => {
//     controller.abort(); // ✅ cancel previous request
//   };
// }, [SearchData]);

//   // ✅ REMOVE GLOBAL SIDE EFFECT WHEN INACTIVE
//   // useEffect(() => {
//   //   if (!isActive || users.length === 0) return;

//   //   const handleKey = (e) => {
//   //     if (e.key === "Enter") {
//   //       const selectedUser = users[activeIndex];

//   //       if (selectedUser) {
//   //         navigate(`/user/${selectedUser._id}/profile`);
//   //         onSelectUser(selectedUser);
//   //         onClose();
//   //       }
//   //     }
//   //   };

//   //   window.addEventListener("keydown", handleKey);

//   //   return () => {
//   //     window.removeEventListener("keydown", handleKey);
//   //   };
//   // }, [users, activeIndex, isActive]);

//   useEffect(() => {
//   if (!isActive || users.length === 0) return;

//   const handleKey = (e) => {
//     if (e.key === "Enter") {
//       const selectedUser = users[activeIndex];
//       if (!selectedUser) return;

//       navigate(`/user/${selectedUser._id}/profile`);
//       onSelectUser(selectedUser);
//       onClose();
//     }
//   };

//   window.addEventListener("keydown", handleKey);

//   return () => {
//     window.removeEventListener("keydown", handleKey);
//   };
// }, [users, activeIndex, isActive, navigate]);

//   // ✅ CRITICAL: DON'T RENDER AT ALL
//   if (!isActive) return null;

//   return (
//     <section>
//       <div className="Search-Container">
//         {loading ? (
//           <div className="no-results">Searching...</div>
//         ) : users.length > 0 ? (
//           users.map((user, index) => (
//             <Link
//               key={user._id}
//               to={`/user/${user._id}/profile`}
//               onClick={() => {
//                 onSelectUser(user);
//                 onClose();
//               }}
//               style={{ textDecoration: "none", color: "inherit" }}
//             >
//               <div
//                 className={`user-profile-img ${
//                   index === activeIndex ? "active" : ""
//                 }`}
//                 onMouseEnter={() => setActiveIndex(index)}
//               >
//                 <img
//                   src={user.profilePic || xyzprofile}
//                   alt="user"
//                 />
//                 <div className="user-info">
//                   <h4>{user.fullName}</h4>
//                   <h5>
//                     {user?.statePrivate}, {user?.districtPrivate}
//                   </h5>
//                 </div>
//               </div>
//             </Link>
//           ))
//         ) : (
//           <div className="no-results">No users found</div>
//         )}
//       </div>
//     </section>
//   );
// }